export const typewriterAnimation = function (element, { typingSpeed, holdTime, wordShouldDisappear }) {
  const phrases = JSON.parse(element.dataset.phrases)
  let phraseindex
  let letterIndex
  let direction
  let currentClassName
  let shouldRun

  function setInitialState() {
    phraseindex = 0
    letterIndex = phrases[phraseindex].text.length
    direction = 1
    currentClassName = phrases[phraseindex].className

    const text = phrases[phraseindex].text
    const className = phrases[phraseindex].className
    element.innerHTML = text.slice(0, letterIndex)

    currentClassName = className
    element.classList.add(currentClassName)

    phrases.forEach(phrase => {
      if (phrase.className !== currentClassName) {
        element.classList.remove(phrase.className)
      }
    })
  }

  function loop() {
    const text = phrases[phraseindex].text
    const className = phrases[phraseindex].className
    element.innerHTML = text.slice(0, letterIndex)
    let timeout = typingSpeed

    if (letterIndex === text.length) {
      direction = -1
      timeout = holdTime
    } else if (letterIndex === 0 && direction === -1) {
      phraseindex = (phraseindex + 1) % phrases.length
      direction = 1
    }

    if (className !== currentClassName) {
      element.classList.remove(currentClassName)
      currentClassName = className
      element.classList.add(currentClassName)
    }

    if (direction === -1 && wordShouldDisappear) {
      letterIndex = 0
    } else {
      letterIndex = letterIndex + direction
    }

    if (shouldRun) {
      setTimeout(loop, timeout)
    }
  }

  setInitialState()

  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
  shouldRun = !mediaQuery.matches

  mediaQuery.addEventListener('change', () => {
    if (mediaQuery.matches && shouldRun === true) {
      shouldRun = false
      setInitialState()
    } else if (!mediaQuery.matches) {
      shouldRun = true
      loop()
    }
  })

  if (shouldRun) {
    setTimeout(loop, typingSpeed)
  }
}
